import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.813 28a11.72 11.72 0 0 0 8.352-3.515A12.1 12.1 0 0 0 27.625 16c0-3.183-1.244-6.235-3.46-8.485A11.72 11.72 0 0 0 15.813 4 11.72 11.72 0 0 0 7.46 7.515 12.1 12.1 0 0 0 4 16c0 3.183 1.245 6.235 3.46 8.485A11.72 11.72 0 0 0 15.813 28m-3.738-15.797a1.09 1.09 0 0 1 1.564 0l2.169 2.203 2.169-2.203a1.09 1.09 0 0 1 1.564 0c.429.44.434 1.153 0 1.59l-2.169 2.202 2.169 2.203c.434.441.434 1.154 0 1.59a1.095 1.095 0 0 1-1.564 0l-2.17-2.204-2.168 2.204a1.09 1.09 0 0 1-1.564 0 1.137 1.137 0 0 1 0-1.59l2.169-2.203-2.169-2.203a1.133 1.133 0 0 1 0-1.589"
    }, null, -1)
  ]))]))
}
export default { render: render }